import axios from 'axios';
const apiEndPoint = process.env.REACT_APP_API_URL;



const getListMobilisations = async () => {
  const response = await axios.get(`${apiEndPoint}/mobilisations`)
  return response.data;

}

export {getListMobilisations};